<script>
    import Vue from 'vue'
export default {
    props: {
        // 组件ref属性
        refAttr: {
            type: String,
            default: '',
        },
        // 组件id属性
        idAttr: {
            type: String,
            default: '',
        },
        // 渲染的内容
        content: {
            type: String,
            default: '',
            required: true,
        },
    },
    mounted() {},
    render(h) {
        // 因为template模板中必须有一个标签作为根元素
        let template = `<div>${this.content}</div>`
        // 将string字符串转换成模板(因为string字符串中包含了自定义组件, 单单使用v-html是解析不了的)
        const element = Vue.extend({
            template,
        })
        return h(element, {
            ref: this.refAttr,
            attrs: {
                id: this.idAttr,
            },
        })
    },
}
</script>

